import { zhCN } from 'date-fns/locale';
import merge from 'lodash/merge';
import error from './error.js';
import login from './login.js';

// Translated by FANJT2024

var zh = {
  language: 'zh',
  country: 'cn',
  name: '中文',
  embeddedLocale: merge(error, login),
  flags: ['CN'],
  dateFns: zhCN,
  format: {
    date: 'yyyy.M.d',
    dateTime: '$t(format:date) $t(format:time)',
    time: 'HH:mm',
  },
};

export { zh as default };
